import { ButtonLoading } from "go-form";

interface ActionButtonProps {
	text: string;
	isPrimary?: boolean;
	onClick: () => void;
	isLoading?: boolean;
	"data-testid"?: string;
	hide?: boolean;
}

export const ActionButton = ({
	text,
	isPrimary,
	onClick,
	isLoading,
	"data-testid": dataTestId,
	hide,
}: ActionButtonProps): JSX.Element => {
	if (hide) return <></>;

	return (
		<ButtonLoading
			variant={isPrimary ? "primary" : "outline-secondary"}
			onClick={onClick}
			data-testid={dataTestId}
			loading={Boolean(isLoading)}
			type="button"
		>
			{text}
		</ButtonLoading>
	);
};
